module.exports = __webpack_public_path__ + "img/img2.73f6e5e1.png";